import { useCallback } from "react";
import { SelectionMode } from "types/Keyword";
import { useKeywordsAndTopicsState } from "../../KeywordsAndTopics.hooks";
import { SummaryTableEntry } from "./SummaryTableEntry";

export const useUnselect = () => {
  const { actions, state } = useKeywordsAndTopicsState();

  return useCallback(
    (selectedRows: SummaryTableEntry[]) => {
      const keywordsToUnselect = selectedRows.filter(
        (row) => row.category === "Keyword",
      );

      actions.setSelectedKeywords(
        state.selectedKeywords.filter((keyword) =>
          keywordsToUnselect.some(
            (row) =>
              keyword.label.toLowerCase() === row.name.toLowerCase() &&
              keyword.metaData?.source === row.selectionMethod,
          ),
        ),
        SelectionMode.UNSELECT,
      );

      const topicsToUnselect = selectedRows.filter(
        (row) => row.category === "Topic",
      );

      actions.setSelectedTopics(
        state.selectedTopics.filter((topic) =>
          topicsToUnselect.some(
            (row) =>
              topic.topicId === row.id && topic.source === row.selectionMethod,
          ),
        ),
        SelectionMode.UNSELECT,
      );
    },
    [actions, state.selectedKeywords, state.selectedTopics],
  );
};
